import { cn } from "@/lib/utils";
import { Loader2Icon } from "lucide-react";
import React from "react";

const LoadingSpinner = ({
  delay = true,
  absolute = false,
  fullHeight = true,
  className,
}: {
  delay?: boolean;
  absolute?: boolean;
  fullHeight?: boolean;
  className?: string;
}) => {
  const [showSpinner, setShowSpinner] = React.useState(
    absolute ? true : !delay,
  );

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinner(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={cn(
        `flex w-full items-center justify-center ${
          absolute && "fixed left-0 top-0 bg-white"
        } ${fullHeight ? "h-full min-h-screen" : "h-64"}`,
        className,
      )}
    >
      <Loader2Icon
        className={`h-12 w-12 animate-spin text-green-800 transition-all ${
          showSpinner ? "opacity-100" : "opacity-0"
        }`}
      />
    </div>
  );
};

export default LoadingSpinner;
